import { debounce } from "./utils";

export default class ObserverModule {
  constructor(controller) {
    this.controller = controller;
    this.observer = null;

    // Criar uma versão com debounce do método de reinicialização
    this.debouncedReinitialize = debounce(() => {
      this.controller.reinitialize();
    }, 500);
  }

  initialize() {
    this.setupMutationObserver();
    this.setupEventListeners();
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    // Remover o listener de evento personalizado
    document.removeEventListener("kanban:updated", this.handleKanbanUpdated);
  }

  setupMutationObserver() {
    // Configurar um observador de mutações para detectar quando o conteúdo é atualizado via Turbo Stream
    this.observer = new MutationObserver((mutations) => {
      // Não reinicializar durante operações de arrastar e soltar
      if (this.controller.isDragging) {
        return;
      }

      let shouldReinitialize = false;

      mutations.forEach((mutation) => {
        // Verificar se a mutação afeta o kanban-scales ou seus filhos
        if (mutation.type === "childList") {
          const kanbanScalesElement = document.getElementById("kanban-scales");

          // Verificar se algum dos nós adicionados ou removidos é o kanban-scales ou está dentro dele
          const affectsKanban =
            Array.from(mutation.addedNodes).some((node) => {
              return (
                node === kanbanScalesElement ||
                (node.nodeType === Node.ELEMENT_NODE &&
                  (node.id === "kanban-scales" ||
                    (kanbanScalesElement &&
                      kanbanScalesElement.contains(node))))
              );
            }) ||
            Array.from(mutation.removedNodes).some((node) => {
              return (
                node === kanbanScalesElement ||
                (node.nodeType === Node.ELEMENT_NODE &&
                  (node.id === "kanban-scales" ||
                    (kanbanScalesElement &&
                      kanbanScalesElement.contains(node))))
              );
            });

          if (affectsKanban) {
            shouldReinitialize = true;
          }
        }
      });

      // Reinicializar apenas se necessário, usando a versão com debounce
      if (shouldReinitialize) {
        this.debouncedReinitialize();
      }
    });

    // Observar mudanças no elemento principal
    this.observer.observe(this.controller.element, {
      childList: true,
      subtree: true,
    });
  }

  setupEventListeners() {
    // Criar uma referência à função que pode ser removida posteriormente
    this.handleKanbanUpdated = this.handleKanbanUpdated.bind(this);
    document.addEventListener("kanban:updated", this.handleKanbanUpdated);
  }

  handleKanbanUpdated() {
    // Apenas reinicializar se não estiver arrastando, usando a versão com debounce
    if (!this.controller.isDragging) {
      this.debouncedReinitialize();
    }
  }
}
